module.exports = __webpack_public_path__ + "static/img/Izack-Tago.1c75c55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Izack-Tago.jpg
// module id = lXfh
// module chunks = 0